import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch } from 'react-icons/fa';
import styled from 'styled-components';

import { uiHelpers } from '../../../helpers';
import { StockLookupEntity } from '../../../py-generated/datalouder/stock/types';
import StockCodeInput from '../../form/StockCodeInput';

const StockInput = styled.div`
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  & > div {
    display: inline-block;
  }
  input {
    width: 60px;
    margin-right: 2px;
  }
  .search-button {
    cursor: pointer;
  }
`;

interface Props {
  stock: StockLookupEntity;
  region: string;
  editingStockCode: string;
  handleEditingStockCode: (value: string) => void;
  handleSearchInputKeyPressed: React.KeyboardEventHandler<HTMLInputElement>;
  handleSearchClick: () => void;
}

const PriceViewerStockCodeSearchField: React.FC<Props> = ({
  stock,
  region,
  editingStockCode,
  handleEditingStockCode,
  handleSearchInputKeyPressed,
  handleSearchClick,
}) => {
  const { i18n } = useTranslation();
  return (
    <StockInput>
      {stock && (
        <div style={{ marginRight: '0.5rem' }}>
          {region === 'us'
            ? uiHelpers.tradChify(stock[`name_${i18n.language}`])
            : stock[`name_${i18n.language}`]}
        </div>
      )}
      <StockCodeInput
        value={editingStockCode}
        onChange={handleEditingStockCode}
        renderInputComponent={inputProps => <input {...inputProps} />}
        onKeyPress={handleSearchInputKeyPressed}
      />
      <FaSearch className="search-button" onClick={handleSearchClick} />
    </StockInput>
  );
};

export default PriceViewerStockCodeSearchField;
